/** @jsxImportSource @emotion/react */

import { useContext, useEffect, useRef } from 'react';
import { ViewContext } from '../contexts/viewContext';
import useSessionStorage from '../hooks/useSessionStorage';

const ScrollManager = () => {
  const { mainElement } = useContext(ViewContext);

  const [getCache] = useSessionStorage<number>('SCROLL_POSITION', {
    locationAware: true,
  });
  const getCacheRef = useRef(getCache);

  // Update hook references.
  useEffect(() => {
    getCacheRef.current = getCache;
  }, [getCache]);

  // Restore scroll position or scroll to top if we have navigated to a new route.
  useEffect(() => {
    window.requestAnimationFrame(() => {
      if (mainElement) {
        const cachedPos = getCacheRef.current();
        const scrollPos = cachedPos || 0;

        window.scrollTo(0, scrollPos);
        mainElement.scrollTop = scrollPos;

        // Ensure scrolled content isn't hidden under fixed nav
        if (scrollPos > 0) {
          const maxScroll = mainElement.scrollHeight - mainElement.clientHeight;
          const adjustedPos = Math.min(scrollPos, maxScroll);
          if (adjustedPos !== scrollPos) {
            mainElement.scrollTop = adjustedPos;
          }
        }
      }
    });
  }, [mainElement]);

  return null;
};

export default ScrollManager;
